import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import { Tooltip, Row, Col, Table, Button } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/skpService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import moment from "moment"

class TableDoneComponent extends Component {
    dataTableBloc = new DataTableBloc();

    queryParams = new URLSearchParams(window.location.search)

    source
    historyTable = 'historySKPtargetApprovalActive'
    defaultOrder = 'skp_id'
    defaultSize = 9999
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;
        // let whereStatus = (this.props.atasan == 1 ? 3 : 4);
        let whereStatus = 4;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: whereStatus,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTargetTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    submitData = async () => {
        await this.dataTableBloc.fetchSendApprove(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                status: 3,
                perioduuid: this.queryParams.get('perioduuid'),
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        // await this.dataTableBloc.fetchDelete({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtargettableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.employee,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.sendApproveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtargettableChannel.unsubscribe()
        this.dataTableBloc.sendApproveChannel.unsubscribe()
    }

    render() {
        return (
            <>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                    <div className="table-responsive">
                        <Table className="table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Kegiatan</th>
                                    <th>Target Angka Kredit</th>
                                    <th>Target kuantitas</th>
                                    <th>Target Output</th>
                                    <th>Target Kualitas Mutu</th>
                                    <th>Target Waktu</th>
                                    <th>Target Satuan Waktu</th>
                                    <th>Target Biaya</th>
                                    {/* <th>Catatan Penilai</th> */}
                                    {/* <th>Catatan Atasan Penilai</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.totalRow > 0 ? 

                                        this.state.rows.map((data, index) => {
                                            return (
                                                <tr key={`skp_${index}`}>
                                                    <td>{index+1}</td>
                                                    <td>{data.skp_activity}</td>
                                                    <td>{data.skp_target_angka_kredit}</td>
                                                    <td>{data.skp_target_kuantitas}</td>
                                                    <td>{data.skp_target_output}</td>
                                                    <td>{data.skp_target_kualitas_mutu}</td>
                                                    <td>{data.skp_target_waktu}</td>
                                                    <td>{data.skp_target_satuan_waktu}</td>
                                                    <td>{data.skp_target_biaya ?? '-'}</td>
                                                    {/* <td>{data.skp_note_target_boss ?? '-'}</td> */}
                                                    {/* <td>{data.skp_note_target_head_boss ?? '-'}</td> */}
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="10" className="text-center">Tidak Ada Data Menunggu Approval</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                        <br />
                        <label htmlFor="" className="label">Catatatan :</label>
                        <AvField
                            name="approval_note"
                            placeholder="Catatan Approval"
                            errorMessage="Masukkan Catatan Approval"
                            type="textarea"
                            className="form-control"
                            style={{ minWidth: '200px' }}
                            value={this.props.catatanApproval}
                            readonly ="readonly"
                        />
                        <br />
                    </div>

                    {/* <Row className="mb-3">
                        <Col md="9">
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Approve Target Kegiatan
                            </Button>
                        </Col>
                    </Row> */}

                </AvForm>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?input_realisasi&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableDoneComponent